<template>
  <div>
    <div
      class="spinner-grow"
      role="status"
      v-if="allLoading === true || loading === true"
    ></div>
    <div class="card-stats-container">
      <SummaryCard
        :logo="require('@/assets/img/people.png')"
        title="Total Terminals"
        :number="this.totalTerminals"
      />

      <SummaryCard
        :logo="require('@/assets/img/configured.png')"
        title="Configured"
        :number="this.configured.count"
        :percentage="this.configured.percent + '% of Total Terminals'"
      />

      <SummaryCard
        :logo="require('@/assets/img/notconfigured.png')"
        title="Not Configured"
        :number="this.notConfigured.count"
        :percentage="this.notConfigured.percent + '% of Total Terminals'"
      />

      <SummaryCard
        :logo="require('@/assets/img/T3.png')"
        title="T3 POS"
        :number="this.types.T3POS.count"
        :percentage="this.types.T3POS.percent + '% of Total Terminals'"
      />

      <SummaryCard
        :logo="require('@/assets/img/MPOS.png')"
        title="MPOS"
        :number="this.types.MPOS.count"
        :percentage="this.types.MPOS.percent + '% of Total Terminals'"
      />

      <SummaryCard
        :logo="require('@/assets/img/card_reader.png')"
        title="CARD READER"
        :number="this.types.CARD_READER.count"
        :percentage="this.types.CARD_READER.percent + '% of Total Terminals'"
      />
    </div>

    <div style="display: flex; gap: 20px">
      <HorizontalBarChart />
      <TerminalPieChart />
    </div>

    <div class="search-container">
      <div class="search-items">
        <div class="col-auto" style="">
          <select
            class="form-control"
            v-model="selectedValue"
            placeholder="Select a search parameter"
          >
            <option value="">Select a search parameter</option>
            <option value="customerName">Agent Name</option>
            <option value="customerCategory">Agent Category</option>
            <option value="walletId">Wallet ID</option>
            <option value="terminalId">Terminal ID</option>
            <option value="terminalType">Terminal Type</option>
            <option value="serialNo">Terminal Serial Number</option>
            <option value="merchantId">Merchant ID</option>
            <option value="configurationStatus">Configuration Status</option>
            <option value="salesOfficer">Sales Officer</option>
          </select>
        </div>

        <div v-if="selectedValue && selectedValue != 'configurationStatus'">
          <div class="input-group m-0">
            <input
              id="inlineFormInputGroup"
              class="form-control"
              v-model="searchValues[selectedValue]"
              :placeholder="`Enter ${selectedValue.replace(/Id/g, ' Id')}`"
              type="text"
            />
          </div>
        </div>

        <div class="col-auto" v-if="selectedValue === 'configurationStatus'">
          <select class="form-control" v-model="searchValues[selectedValue]">
            <option value="">Select a configuration status</option>
            <option value="true">NOT CONFIGURED</option>
            <option value="false">CONFIGURED</option>
          </select>
        </div>
      </div>

      <div class="action_btns">
        <button
          type="submit"
          class="btn btn-blue"
          :disabled="isSearchDisabled"
          @click="refresh('filter')"
        >
          FILTER
        </button>

        <button class="btn btn-blue" @click="refresh('refresh')">
          REFRESH
        </button>

        <button class="btn btn-blue" @click="refresh('download')">
          EXPORT CSV
        </button>
      </div>
    </div>

    <div class="col-12 p-0">
      <card class="card-plain p-0">
        <div class="table-responsive p-0">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col" class="text-center">S/N</th>
                <th scope="col" class="text-center">Agent Name</th>
                <th scope="col" class="text-center">Agent Category</th>
                <th scope="col" class="text-center">Wallet ID</th>
                <th scope="col" class="text-center">Terminal ID</th>
                <th scope="col" class="text-center">Terminal Serial Number</th>
                <th scope="col" class="text-center">Terminal Type</th>
                <th scope="col" class="text-center">Merchant ID</th>
                <th scope="col" class="text-center">Configuration Status</th>
                <th scope="col" class="text-center">SalesOfficer</th>
              </tr>
            </thead>

            <tbody>
              <tr v-if="loadingAgents === true">
                <td colspan="100%" class="text-center">
                  <div>
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading Agents...</span>
                    </div>
                  </div>
                </td>
              </tr>

              <tr v-else-if="terminals.length === 0 && loadingAgents === false">
                <td colspan="100%" class="text-center">
                  <div class="">
                    <div class="alert-icon">
                      <i class="fa fa-info-circle"></i>
                    </div>
                    <span>No Agents Found</span>
                  </div>
                </td>
              </tr>

              <template v-else>
                <tr
                  v-for="(terminal, index) in terminals"
                  :key="terminal._id"
                  style="background-color: #fff"
                >
                  <th class="text-center">
                    {{ limit * (currentPage - 1) + (index + 1) }}
                  </th>
                  <td class="text-center">
                    {{ terminal.agentName }}
                  </td>

                  <td class="text-center">
                    {{ terminal.tmsMerchantName }}
                  </td>

                  <td class="text-center">{{ terminal.walletId }}</td>
                  <td class="text-center">{{ terminal.terminalId }}</td>
                  <td class="text-center">{{ terminal.serialNo }}</td>
                  <td class="text-center">{{ terminal.terminalType }}</td>
                  <td class="text-center">{{ terminal.merchantId }}</td>
                  <td class="text-center">
                    <span
                      class="status"
                      :class="
                        terminal.forceConfig
                          ? 'status-disabled'
                          : 'status-enabled'
                      "
                      >{{
                        terminal.forceConfig ? "NOT CONFIGURED" : "CONFIGURED"
                      }}</span
                    >
                  </td>

                  <td class="text-center">
                    {{ getSalesOfficerName(terminal.salesOfficerId) || "N/A" }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </card>
    </div>

    <div class="pagination">
      <div
        class="to-flex"
        style="display: flex; align-items: center; gap: 10px"
      >
        <button
          class="btn"
          :disabled="hasPrevPage === false"
          @click="refresh('previous')"
        >
          Previous
        </button>

        <span>Page {{ currentPage }} of {{ totalPages }}</span>

        <button class="btn" :disabled="!hasNextPage" @click="refresh('next')">
          Next
        </button>
      </div>

      <div class="p-2">
        <div class="btn">Total Records: {{ totalDocs }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../store/axios";
import moment from "moment";
import { convertArrayToCSV } from "convert-array-to-csv";
import fileDownload from "js-file-download";
import SummaryCard from "../components/Cards/SummaryCard.vue";
import { ChartCard } from "@/components/index";

// import { Pie, HorizontalBar } from "vue-chartjs";
// import "chart.js/dist/Chart.min.css";
import Chartist from "chartist";

// const Chartist = require("chartist");
import "chartist/dist/chartist.min.css";

import TerminalPieChart from "../pages/PieChart.vue";
import HorizontalBarChart from "../pages/HorizontalBarChart.vue";

export default {
  components: {
    SummaryCard,
    ChartCard,
    TerminalPieChart,
    HorizontalBarChart,
  },

  data() {
    return {
      allLoading: false,
      loading: false,
      loadingAgents: false,
      errorMsg: "",
      error: false,
      totalTerminals: 0,
      configured: {},
      notConfigured: {},
      types: {},
      currentPage: 1,
      moment,
      format: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      page: 1,
      limit: 50,
      totalPages: 0,
      totalDocs: 0,
      hasPrevPage: false,
      hasNextPage: false,
      prevPage: null,
      nextPage: null,
      terminals: [],
      filteredAgentList: [],
      download: false,
      searchValues: {
        terminalId: "",
        walletId: "",
        serialNo: "",
        merchantId: "",
        agentId: "",
        salesOfficer: "",
        customerCategory: "",
        customerName: "",
        configurationStatus: "",
      },
      selectedValue: "",
      inputError: false,
      createdAtStartDate: "",
      createdAtEndDate: "",
      activationStartDate: "",
      activationEndDate: "",
      dateError: false,
      allMerchants: [],
      chartData: {
        labels: [],
        series: [],
      },
      customerCategories: [],
      allSalesOfficers: [],
      pieChartData: {
        labels: [],
        counts: [],
        datasets: [
          {
            backgroundColor: ["#75D7F0", "#1687A4", "#3CAFCD"],
            data: [],
          },
        ],
      },
      pieOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
      },

      barChartData: {
        labels: [],
        datasets: [
          {
            label: "Merchants",
            backgroundColor: "#65B3C7",
            borderRadius: 10,
            data: [],
          },
        ],
      },
      barOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          yAxes: [
            {
              gridLines: { display: false },
            },
          ],
        },
      },
      sortOrder: "desc",
      categoriesStates: [],

      typesdata: {
        T3POS: { count: 2, percent: "1.8" },
        MPOS: { count: 3, percent: "2.8" },
        CARD_READER: { count: 1, percent: "0.9" },
      },
    };
  },

  computed: {
    searchValue: {
      get() {
        return this.selectedValue ? this.searchValues[this.selectedValue] : "";
      },
      set(value) {
        if (this.selectedValue) {
          this.searchValues[this.selectedValue] = value;
        }
      },
    },

    isSearchDisabled() {
      switch (this.selectedValue) {
        case "customerName":
          return !this.searchValues;

        case "customerCategory":
          return !this.searchValues;

        case "walletId":
          return !this.searchValues;
        case "terminalId":
          return !this.searchValues;
        case "serialNo":
          return !this.searchValues;
        case "forceConfig":
          return !this.searchValues;
        case "terminalType":
          return !this.searchValues;
        case "merchantId":
          return !this.searchValues;
        case "salesOfficer":
          return !this.searchValues;
        case "configurationStatus":
          return !this.searchValues;
        default:
          return true;
      }
    },
  },

  methods: {
    async getTerminals() {
      this.loading = true;
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/analytics/terminal-summary`,
        );

        console.log("terminals", res.data.data);
        const { totalTerminals, configured, notConfigured, types } =
          res.data.data;

        this.totalTerminals = totalTerminals;
        this.configured = configured;
        this.notConfigured = notConfigured;
        this.types = types;
        this.buildChartData();

        this.loading = false;
      } catch (err) {
        this.loading = false;
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch Terminals",
          });
        }
      }
    },

    buildBarChartData() {
      // Clone array so you don’t mutate original
      let dataArray = [...this.customerCategories];

      // sort logic
      if (this.sortOrder === "asc") {
        dataArray.sort((a, b) => a.count - b.count);
      } else {
        dataArray.sort((a, b) => b.count - a.count);
      }

      // Build labels & data from sorted array
      const labels = dataArray.map((item) => item.merchantName);
      const values = dataArray.map((item) => Number(item.count));

      this.barChartData.labels = labels;
      this.barChartData.datasets[0].data = values;

      // Render the chart
      if (this.$refs.hbar) {
        this.$refs.hbar.renderChart(this.barChartData, this.barOptions);
      }
    },

    async getCustomerCategories() {
      this.loading = true;
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/analytics/account-type-overview`,
        );

        this.customerCategories = res.data.data.customerCategories;

        this.buildBarChartData();

        this.loading = false;
      } catch (err) {
        this.loading = false;
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    async getCustomerStates() {
      this.loading = true;
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/analytics/group/terminals?groupBy=state`,
        );

        console.log("customerStates", res.data.data);
        this.categoriesStates = res.data.data;

        this.loading = false;
      } catch (err) {
        this.loading = false;
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    sortAndBuildChart() {
      this.buildBarChartData();
    },

    buildChartData() {
      this.pieChartData.labels = ["T3 POS", "MPOS", "CARD READER"];
      this.pieChartData.counts = [
        Number(this.types.T3POS.count),
        Number(this.types.MPOS.count),
        Number(this.types.CARD_READER.count),
      ];
      this.pieChartData.datasets[0].data = [
        Number(this.types.T3POS.percent) || 0,
        Number(this.types.MPOS.percent) || 0,
        Number(this.types.CARD_READER.percent) || 0,
      ];

      this.$refs.pie.renderChart(this.pieChartData, this.pieOptions);
      console.log("pieChartData", this.pieChartData);
      console.log("pieOptions", this.pieOptions);
    },

    getFormattedStatus(status) {
      const statusMap = {
        verified: "Verified",
        partially_verified: "Partially Verified",
        rejected: "Rejected",
        pending: "Pending",
        unverified: "Unverified",
      };
      return statusMap[status] || status;
    },

    async getMerchants() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/external-request/merchant/get-all-merchants`,
        );

        const { merchants } = res.data;
        this.allMerchants = merchants;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    getMerchantName(id) {
      const merchant = this.allMerchants.find(
        (merchant) => merchant._id === id,
      );
      return merchant ? merchant.merchantName : "";
    },

    async refresh(mode) {
      try {
        this.loading = true;
        this.errorMsg = "";
        this.error = false;
        let payload = {
          page: this.page,
          ...this.searchValues,
        };
        switch (mode) {
          case "next":
            payload = { ...payload, page: this.nextPage };
            this.currentPage = this.nextPage;
            break;
          case "previous":
            payload = { ...payload, page: this.prevPage };
            this.currentPage = this.prevPage;
            break;
          case "download":
            payload = { ...payload, download: true };
            break;
          case "refresh":
            payload = { page: this.page };
            this.selectedValue = "";
            this.searchValues = "";
            this.currentPage = 1;
            break;
          case "filter":
            this.page = 1;
            this.currentPage = 1;

            payload = {
              ...payload,
              page: this.page,
              ...this.searchValues,
            };
            break;
        }
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/analytics/all-terminals`,
          payload,
        );
        if (mode === "download") {
          const csvTran = convertArrayToCSV(res.data.terminals);
          fileDownload(csvTran, "terminals.csv");
        } else {
          const {
            docs,
            hasNextPage,
            hasPrevPage,
            totalPages,
            prevPage,
            nextPage,
          } = res.data.terminals;
          this.terminals = docs;
          this.hasPrevPage = hasPrevPage;
          this.hasNextPage = hasNextPage;
          this.totalPages = totalPages;
          this.prevPage = prevPage;
          this.nextPage = nextPage;
        }
      } catch (err) {
        console.log(err);
        this.error = true;
        this.errorMsg = "Unable to Fetch Terminals";
      }
      this.loading = false;
    },

    async getSalesOfficers() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/external-request/user/get-all-users`,
        );
        this.allSalesOfficers = res.data.users;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    getSalesOfficerName(id) {
      const officer = this.allSalesOfficers.find(
        (officer) => officer._id === id,
      );
      if (!officer) return "";

      return officer.lastName
        ? `${officer.firstName} ${officer.lastName}`
        : officer.firstName;
    },

    clearSearchFields() {
      this.searchValues = {
        terminalId: "",
        walletId: "",
        serialNo: "",
        forceConfig: "",
        merchantId: "",
        agentId: "",
        salesOfficer: "",
        customerCategory: "",
        customerName: "",
        configurationStatus: "",
      };
    },

    buildChartistPie() {
      console.log("Pie element:", document.querySelector(".pieChart"));
      console.log("Building pie...");
      const labels = Object.keys(this.typesdata);
      const series = Object.values(this.typesdata).map((t) => t.count);

      new Chartist.Pie(
        this.$refs.pieChart,
        {
          labels: labels,
          series: series,
        },
        {
          showLabel: true,
        },
      );
    },
  },

  watch: {
    selectedValue(newValue, oldValue) {
      if (oldValue && newValue !== oldValue) {
        const tempValue = newValue;
        this.refresh("refresh");
        this.selectedValue = tempValue;
      }
      this.clearSearchFields();
      this.previousValue = newValue;
    },
  },

  async mounted() {
    this.allLoading = true;
    this.getTerminals();
    this.getCustomerCategories();
    try {
      this.loading = true;
      const res = await axios.post(
        `${process.env.VUE_APP_API_URL}/analytics/all-terminals`,
        {
          page: this.page,
        },
      );
      console.log(res);
      const {
        docs,
        hasNextPage,
        hasPrevPage,
        totalPages,
        prevPage,
        nextPage,
        totalDocs,
      } = res.data.terminals;
      this.terminals = docs;
      console.log(this.terminals);
      this.hasPrevPage = hasPrevPage;
      this.hasNextPage = hasNextPage;
      this.totalPages = totalPages;
      this.prevPage = prevPage;
      this.nextPage = nextPage;
      this.totalDocs = totalDocs;
    } catch (err) {
      console.log(err);
      this.error = true;
      this.errorMsg = "Unable to Fetch Terminals";
    }
    this.loading = false;
    this.getMerchants();
    this.getCustomerStates();
    this.getSalesOfficers();
    this.$nextTick(() => {
      this.buildChartistPie();
    });
    this.allLoading = false;
  },
};
</script>

<style scoped>
.card-stats-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.status {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
}
.status-enabled {
  background: #1eb75b;
  color: #fff;
}
.status-disabled {
  background: #e02b00;
  color: #fff;
}
.status-other {
  color: #b5af03;
  background: rgba(181, 175, 3, 0.1);
}

.statuses {
  text-transform: capitalize;
  font-size: 14px;
  border-radius: 4px;
  padding: 4px 12px;
  display: flex;
  justify-content: center;
}

.all-status-verified {
  color: #1eb75b;
  background: rgba(30, 183, 91, 0.1);
}
.all-status-partially-verified {
  color: #b5af03;
  background: rgba(181, 175, 3, 0.1);
}
.all-status-rejected {
  color: #e02b00;
  background: rgba(224, 43, 0, 0.1);
}
.all-status-pending {
  color: #f2b630;
  background: rgba(242, 182, 48, 0.1);
}
.all-status-unverified {
  color: #6880e4;
  background: rgba(104, 128, 228, 0.1);
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.search-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-top: 24px;
}

.action_btns {
  display: flex;
  align-items: center;
  gap: 12px;
}

.search-items {
  display: flex;
  align-items: center;
  gap: 30px;
}

.small-pie {
  width: 100%;
  height: 300px;
}
.pie-chart-container,
.bar-container {
  background: white;
  padding: 16px;
  border-radius: 8px;
  height: 100%;
}

.pie-chart-container h2 {
  margin: 0;
  color: black;
  width: fit-content;
  font-weight: 600;
  font-size: 28px;
  margin-bottom: 20px;
}

.bar-container {
  /* height: 300px; */
  width: 100%;
}

.sort-by {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.sort-by h2 {
  margin: 0;
  color: black;
  width: fit-content;
  font-weight: 600;
  font-size: 28px;
}

.pieChart {
  height: 300px;
}
</style>
